const findPwd = {
  path: 'findPwd',
  component: resolve => require(['../../../../pages/home/user/find-pwd'], resolve)
}

export default findPwd
